export const IMPORT_EXPORT_HISTORIES_PER_PAGE = 50;
